module.exports = __webpack_public_path__ + "187cd2779ea928c7340345adca44daae.png";